import React from 'react';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Mail, Users, Heart, ExternalLink } from 'lucide-react';
export const Contact = () => {
  return <div className="pt-20 min-h-screen bg-gray-50" data-id="element-361">
      <Section data-id="element-362">
        <div className="max-w-5xl mx-auto" data-id="element-363">
          <div className="text-center mb-16" data-id="element-364">
            <h1 className="text-4xl font-bold text-[#1C274C] mb-6" data-id="element-365">
              Get Involved
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-366">
              Join us in shaping the future of AI education in Africa. There are
              many ways to contribute to our mission.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-367">
            {/* Join Waitlist */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-[#3AB5E8]/20" data-id="element-368">
              <div className="w-16 h-16 bg-[#3AB5E8]/10 rounded-full flex items-center justify-center mb-6" data-id="element-369">
                <Users className="w-8 h-8 text-[#3AB5E8]" data-id="element-370" />
              </div>
              <h3 className="text-2xl font-bold text-[#1C274C] mb-4" data-id="element-371">
                Join the Waitlist
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-372">
                Bring AI education to your school or community. Sign up to be
                notified when programs launch in your area.
              </p>
              <a href="https://forms.gle/yiZQndnfYhzdQtX68" target="_blank" rel="noopener noreferrer" data-id="element-373">
                <Button className="w-full" rightIcon={<ExternalLink className="w-4 h-4" data-id="element-375" />} data-id="element-374">
                  Join Waitlist
                </Button>
              </a>
            </div>

            {/* Volunteer */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-[#FC963E]/20" data-id="element-376">
              <div className="w-16 h-16 bg-[#FC963E]/10 rounded-full flex items-center justify-center mb-6" data-id="element-377">
                <Heart className="w-8 h-8 text-[#FC963E]" data-id="element-378" />
              </div>
              <h3 className="text-2xl font-bold text-[#1C274C] mb-4" data-id="element-379">
                Volunteer
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-380">
                Share your skills and passion. Help us create content, train
                educators, or support program delivery.
              </p>
              <a href="https://forms.gle/mj5tBF2xmD7tmg12A" target="_blank" rel="noopener noreferrer" data-id="element-381">
                <Button variant="secondary" className="w-full" rightIcon={<ExternalLink className="w-4 h-4" data-id="element-383" />} data-id="element-382">
                  Volunteer With Us
                </Button>
              </a>
            </div>

            {/* Partner */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-[#389C70]/20" data-id="element-384">
              <div className="w-16 h-16 bg-[#389C70]/10 rounded-full flex items-center justify-center mb-6" data-id="element-385">
                <Mail className="w-8 h-8 text-[#389C70]" data-id="element-386" />
              </div>
              <h3 className="text-2xl font-bold text-[#1C274C] mb-4" data-id="element-387">
                Partner With Us
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-388">
                Organizations, schools, and funders — let's collaborate to scale
                AI education across Africa.
              </p>
              <a href="mailto:info@aiforkidsafrica.com" data-id="element-389">
                <Button variant="outline" className="w-full border-2" data-id="element-390">
                  Email Us
                </Button>
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-[#1C274C] text-white p-12 rounded-3xl text-center" data-id="element-391">
            <h2 className="text-3xl font-bold mb-4" data-id="element-392">Have Questions?</h2>
            <p className="text-xl text-gray-300 mb-8" data-id="element-393">
              We'd love to hear from you. Reach out to discuss partnerships,
              programs, or how you can support our mission.
            </p>
            <div className="flex flex-col items-center gap-6 mb-8" data-id="element-394">
              <div className="flex items-center gap-2" data-id="element-395">
                <Mail className="w-5 h-5" data-id="element-396" />
                <a href="mailto:info@aiforkidsafrica.com" className="text-lg hover:text-[#3AB5E8] transition-colors" data-id="element-397">
                  info@aiforkidsafrica.com
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="border-t border-white/20 pt-8" data-id="element-398">
              <p className="text-gray-300 mb-4" data-id="element-399">
                Connect with us on social media
              </p>
              <div className="flex justify-center gap-6" data-id="element-400">
                <a href="https://linkedin.com/company/ai-for-kids" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#0A66C2] transition-colors" data-id="element-401">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-402">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-403" />
                  </svg>
                </a>
                <a href="https://youtube.com/@aiforkidsglobal" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-404">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-405">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-406" />
                  </svg>
                </a>
                <a href="https://instagram.com/aiforkidsafrica" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#E4405F] transition-colors" data-id="element-407">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-408">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-409" />
                  </svg>
                </a>
                <a href="https://x.com/aiforkidsafrica" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-410">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-411">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-412" />
                  </svg>
                </a>
                <a href="https://tiktok.com/@ai.for.kids.africa" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-413">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-414">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-415" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>;
};